import { useState } from "react";
import { Modal, Typography, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import CsvDownloader from "react-csv-downloader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { generatePDF } from "utils/PerformanceHelperFunctions";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
  borderRadius: "0.5rem",
  border: "none",
};

function ExportReportModal({ open, handleClose, filters, csvData, filterDates }) {
  const { performance } = useSelector((state) => state.performance);
  const [value, setValue] = useState("CSV");

  const { startDate, endDate } = filterDates;
  // Create Date objects from the startDate and endDate strings
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  // Format the dates in the desired format
  const formattedStartDate = `${
    startDateObj.getMonth() + 1
  }-${startDateObj.getDate()}-${startDateObj.getFullYear()}`;
  const formattedEndDate = `${
    endDateObj.getMonth() + 1
  }-${endDateObj.getDate()}-${endDateObj.getFullYear()}`;
  // Append the formatted dates to the filename
  const filename = `alysio-performance-report-${formattedStartDate}_${formattedEndDate}`;

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const exportPDF = async () => {
    try {
      const pdf = await generatePDF(performance, filters);
      pdf.save(`${filename}.pdf`);
      enqueueSnackbar(
        JSON.stringify({
          icon: "success",
          title: "Success",
          text: "PDF Export Downloaded.",
        }),
        {
          variant: "custom",
        }
      );
    } catch (error) {
      console.error("Failed to export PDF:", error);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: "PDF Export Failed. Something Went Wrong.",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title">
      <MDBox sx={style}>
        <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ mb: 1 }}>
          Export Options
        </Typography>
        <RadioGroup aria-label="export format" value={value} onChange={handleChange} row>
          <FormControlLabel value="CSV" control={<Radio />} label="CSV" />
          <FormControlLabel value="PDF" control={<Radio />} label="PDF" />
        </RadioGroup>
        <MDBox sx={{ display: "flex", justifyContent: "flex-end", mt: 5 }}>
          <MDButton type="button" onClick={handleClose} color="gray80" sx={{ mr: 1 }}>
            Cancel
          </MDButton>
          {value === "PDF" ? (
            <MDButton type="button" onClick={() => exportPDF()} color="primaryRed">
              Export
            </MDButton>
          ) : (
            <CsvDownloader
              datas={csvData.data}
              filename={filename}
              extension=".csv"
              separator=","
              columns={csvData.columns}
              title={csvData.title}
            >
              <MDButton color="primaryRed">Export</MDButton>
            </CsvDownloader>
          )}
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default ExportReportModal;
